export const isInMarketNJ = (geo) => {
    const city = geo?.city;
    if (!city) return false;
    const parts = city.split(',');
    return parts[parts.length - 1].trim() === 'NJ';
};

export const isInMarketLocation = (geo) => !geo?.city?.trim() || isInMarketNJ(geo);

export default isInMarketLocation;
